import {
  Dialog,
  DialogPanel,
  Transition,
  TransitionChild,
} from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { ButtonBase } from "../index.tsx";
import { Fragment } from "react";

type UntitledModalWrapperProps = {
  isOpen: boolean;
  handleCloseModal: () => void;
  isLoading?: boolean;
  containerClass?: string;
  children: React.ReactNode;
  disableXmark?: boolean;
};

const UntitledModalWrapper = ({
  isOpen,
  isLoading,
  containerClass,
  children,
  disableXmark,
  handleCloseModal,
}: UntitledModalWrapperProps) => {
  return (
    <Transition as={Fragment} appear show={isOpen}>
      <Dialog as="div" onClose={() => {}}>
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 z-50 bg-black/25" />
        </TransitionChild>
        <div className="fixed inset-0 overflow-y-auto z-50">
          <div className="flex min-h-full items-center justify-center">
            <DialogPanel
              className={`min-w-max bg-white rounded-lg py-4 px-6 flex flex-col gap-2 shadow-xl ${containerClass}`}
            >
              <section className="relative">
                <ButtonBase
                  className="text-subHeading absolute right-0 top-0"
                  icon={<XMarkIcon className="size-6" />}
                  buttonType="tertiary"
                  onClick={handleCloseModal}
                  disabled={disableXmark}
                />
              </section>
              {isLoading ? (
                <div className="h-56 bg-lightGray rounded-lg animate-pulse" />
              ) : (
                children
              )}
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default UntitledModalWrapper;
